import React, {useEffect} from "react";
import "./Navbar.css";
import { NavLink, useLocation, matchPath } from "react-router-dom";

import home_icon from '../../assets/images/home.svg'
import home_icon_blue from '../../assets/images/home_blue.svg'
import list_icon from '../../assets/images/list.svg'
import list_icon_blue from '../../assets/images/list_blue.svg'
import add_icon from '../../assets/images/plus.svg'
import add_icon_blue from '../../assets/images/plus_blue.svg'

export default function Navbar() {
    let activeClassName = "active_page";

    //----
    const location = useLocation();
    const match = (p) => { return matchPath({ path: p}, location.pathname) }


    useEffect(()=>{
    },[])

    return (
        <nav id="contentNav">
             <div id="menu_list" className="mt-5">
                <NavLink to="/" className={({ isActive }) =>
                    isActive ? activeClassName : undefined
                }>
                    <img alt="" src={home_icon} className="white"/>
                    <img alt="" src={home_icon_blue} className="blue"/>
                    <span>Home</span>
                </NavLink>
            </div>
        </nav>
    )
}